import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.999 1.332a6.667 6.667 0 1 1-.001 13.334 6.667 6.667 0 0 1 .001-13.334m-1.116 3.99a.667.667 0 0 0 0 1.334h1.516L5.518 9.537a.667.667 0 0 0 .943.943L9.34 7.6v1.516a.667.667 0 0 0 1.335 0V5.99a.667.667 0 0 0-.667-.667z"
    }, null, -1)
  ])))
}
export default { render: render }